export default __webpack_public_path__ + "static/media/uploadResumeIcon.51e6061f.svg";